import type { Dimensions } from './types'

export const IMAGE_HEADER_LIMIT = 64 * 1024
const pngSignature = [137, 80, 78, 71, 13, 10, 26, 10]
const sofMarkers = new Set([0xc0, 0xc1, 0xc2, 0xc3, 0xc5, 0xc6, 0xc7, 0xc9, 0xca, 0xcb, 0xcd, 0xce, 0xcf])

function dimensions(w: number, h: number): Dimensions | null {
  return w > 0 && h > 0 ? { w, h } : null
}

export function parseImageHeader(buffer: ArrayBuffer): Dimensions | null {
  const bytes = new Uint8Array(buffer, 0, Math.min(buffer.byteLength, IMAGE_HEADER_LIMIT))
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength)
  if (bytes.length >= 33 && pngSignature.every((byte, i) => bytes[i] === byte)) {
    if (view.getUint32(8) !== 13 || view.getUint32(12) !== 0x49484452) return null
    return dimensions(view.getUint32(16), view.getUint32(20))
  }
  if (bytes[0] !== 0xff || bytes[1] !== 0xd8) return null
  let offset = 2
  while (offset < bytes.length) {
    if (bytes[offset++] !== 0xff) return null
    while (bytes[offset] === 0xff) offset++
    const marker = bytes[offset++]
    if (marker === undefined || marker === 0xda || marker === 0xd9 || marker === 0) return null
    if (marker === 0x01 || (marker >= 0xd0 && marker <= 0xd7)) continue
    if (offset + 2 > bytes.length) return null
    const length = view.getUint16(offset)
    if (length < 2 || offset + length > bytes.length) return null
    if (sofMarkers.has(marker)) {
      if (length < 8) return null
      const components = bytes[offset + 7]
      if (components === 0 || length !== 8 + 3 * components) return null
      return dimensions(view.getUint16(offset + 5), view.getUint16(offset + 3))
    }
    offset += length
  }
  return null
}
